"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (password) {
    return (/^[ -~]{6,25}$/.test(password)
    );
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/misc/isValidPassword.js
// module id = 100
// module chunks = 0